import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtHttpInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    // Get token from localStorage (where it should be stored after authentication)
    let token = localStorage.getItem('token') || localStorage.getItem('jwt_token') || localStorage.getItem('access_token');
    
    if (token) {
      // Remove quotes if they exist around the token
      token = token.replace(/^["']|["']$/g, '');
     
      const cloned = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
      return next.handle(cloned);
    }
    
    return next.handle(req);
  }
}
